import { Stack, Text } from "@mantine/core";
import { Link, useSearch } from "@tanstack/react-router";

import { AuthSecondaryButton, AuthShell } from "../../ui/AuthShell";
import { PROBLEM, problemOf } from "./words";

/**
 * Where `/api/oauth/authorize` sends the browser when it cannot prove the app or the way back to
 * it (spec platform/mcp-oauth, decision 22): nothing goes back to the app, so the page says why
 * and ends here. It needs no session.
 */
export function ProblemScreen() {
  const { reason } = useSearch({ from: "/oauth/problem" });
  return (
    <AuthShell title={PROBLEM.title}>
      <Stack gap={8}>
        <Text size="sm">{problemOf(reason)}</Text>
        <Text size="sm" c="var(--cai-color-text-muted)">
          {PROBLEM.nothing}
        </Text>
      </Stack>
      <AuthSecondaryButton component={Link} to="/">
        {PROBLEM.home}
      </AuthSecondaryButton>
    </AuthShell>
  );
}
